<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Report_pictures"
    :submit="submit" :status="status">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider ref="user_id" rules="required" v-slot="{ errors }">
                <v-select :error-messages="errors" v-model="data.user_id" prepend-inner-icon="fas fa-user"
                  :items="users" item-text="full_name" item-value="id" label="Usuario"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="picture_id" rules="required" v-slot="{ errors }">
                <v-select :error-messages="errors" v-model="data.picture_id" prepend-inner-icon="fas fa-number"
                  :items="pictures" item-text="picture_url" item-value="id" label="Imagen Reportada"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <label>Motivo</label>
              <ValidationProvider ref="reason" rules="" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.reason" solo rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="enabled" rules="" v-slot="{ errors }">
                <v-checkbox v-model="data.enabled" label="Inhabilitar imagen"></v-checkbox>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  async created() {
    const self = this;
    await self.$store.dispatch('Users/getListAll', { enabled: false });

    let pictures = await self.$store.dispatch('Report_pictures/getPictures', { enabled: false });
    this.pictures = pictures;

    if (this.$route.params.id) {
      let report_picture = self.$store.dispatch('Report_pictures/getListAll', { id: this.$route.params.id });
      this.data.enabled = report_picture[0].receiver_id.enabled;
    }
  },
  data() {
    return {
      storeName: "Report_pictures",
      title: "Imagen Reportada",
      show1: false,
      picture_enabled: '',
      data: {
        user_id: "",
        picture_id: "",
        reason: "",
        enabled: '',
      },
      pictures: []
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Report_pictures.status,
      // pictures: state => state.Report_pictures.list,
      users: (state) => state.Users.list,
    }),
  },
  watch: {

  },
  methods: {

  },
};
</script>
